<template>
  <div class="menu-banner">
    <div class="img-wrap">
      <img src="../assets/images/testibg.webp" alt="aboutbg" />
    </div>
    <div class="container">
      <div class="text-content">
        <h2 class="title">{{ title }}</h2>
        <div class="breadcrumb">
          <a-breadcrumb>
            <a-breadcrumb-item>
              <a href>{{ crumb }}</a>
            </a-breadcrumb-item>
          </a-breadcrumb>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerOne",
  props: {
    title: String,
    crumb: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.menu-banner {
  position: relative;
  overflow: hidden;
  background: #f5f5f5;
  max-height: 300px;
  display: flex;
  align-items: center;
  .img-wrap {
    position: absolute;
    left: 0;
    width: 100%;
    top: 0;
    height: 100%;
  }
  .text-content {
    text-align: center;
    padding: 160px 20px;
    .title {
      color: #282828;
      font-size: 36px;
      font-weight: 600;
      margin-bottom: 10px;
      font-family: $main-font;
    }
    .breadcrumb {
      .ant-breadcrumb {
        font-family: $head-font;
        a {
          color: $brand-color;
          font-size: 26px;
          text-transform: capitalize;
        }
        .ant-breadcrumb-separator {
          color: $brand-color !important;
        }
      }
    }
  }
}
</style>